import env from 'utils/env';
import request from './request';

export async function fetchInvoicePreview(lineItems) {
  const url = `${env.paymentApi}/invoices/preview`;
  try {
    const response = await request(
      url,
      'POST',
      {
        'Content-Type': 'application/json',
      },
      JSON.stringify(lineItems)
    );
    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export function checkout(cartId) {
  const requestUrl = `${env.aceApi}/1/invoices/carts/${cartId}`;
  return request(
    requestUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    '',
    true,
    false
  );
}

export const getCredits = () =>
  request(`${env.aceApi}/1/credits/campaigns/default`);
